"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
require("../lib/googleAds");
var ResponsiveAdManager = (function () {
    function ResponsiveAdManager(config) {
        this.config = {
            desktopMode: false
        };
        this.resizeTimeoutID = null;
        this.processed = [];
        if (!googletag) {
            throw new Error('global variable googletag not defined, googletag is required.');
        }
        this.config = jquery_1.default.extend({}, this.config, config);
        this.processAd = jquery_1.default.proxy(this.processAd, this);
        if (window.__cmp) {
            var me_1 = this;
            window.__cmp('consentDataExist', false, function (data) {
                if (data) {
                    console.log('CONSENT [', data, ']');
                    jquery_1.default(window).resize(function () {
                        me_1.killProcesses();
                        me_1.resizeTimeoutID = setTimeout(function () {
                            me_1.process();
                        }, 50);
                    });
                }
            });
        }
    }
    ResponsiveAdManager.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    ResponsiveAdManager.prototype.getCurrentView = function () {
        var width = window.innerWidth || document.documentElement.clientWidth;
        if (this.config.desktopMode) {
            return 'large';
        }
        if (width < 640) {
            return 'small';
        }
        else if (width >= 640 && width < 860) {
            return 'medium';
        }
        else if (width >= 1024) {
            return 'large';
        }
        else if (width >= 860 && width < 1024) {
            return 'mediumlarge';
        }
    };
    ResponsiveAdManager.prototype.preprocess = function () {
        jquery_1.default('.ad.inject').each(function (index, node) {
            var target = jquery_1.default(node.getAttribute('data-inject-target'));
            var position = node.getAttribute('data-inject-position') || 2;
            var ad = jquery_1.default(node);
            ad.removeClass('inject');
            if (target.length === 1) {
                var children = target.children();
                var paragraphs = children.filter('p:not(:empty)');
                var candidate = jquery_1.default(paragraphs[position]);
                if (paragraphs.length > 3
                    && children.length === children.filter('p, div.inline-content.image').length) {
                    while (jquery_1.default.trim(candidate.text()) == jquery_1.default.trim(candidate.children('strong').text())
                        && candidate.next().length) {
                        candidate = candidate.next();
                    }
                    candidate.after(node);
                }
                else {
                    target.append(node);
                }
            }
        });
    };
    ResponsiveAdManager.prototype.process = function () {
        this.preprocess();
        var view = this.getCurrentView();
        var query = '.ad[data-view=' + view + ']';
        var cur = this.processed.length;
        jquery_1.default('.ad[data-view=all]').each(this.processAd);
        jquery_1.default(query).each(this.processAd);
        if (view == 'large') {
            jquery_1.default('.ad[data-view=mediumlarge]').each(this.processAd);
        }
        return this.processed.length - cur;
    };
    ResponsiveAdManager.prototype.killProcesses = function () {
        clearTimeout(this.resizeTimeoutID);
    };
    ResponsiveAdManager.prototype.processAd = function (index, node) {
        if (this.processed.indexOf(node) > -1) {
            return;
        }
        var id = node.getAttribute('id');
        var ref = node.getAttribute('data-slot-ref');
        var sizes = jquery_1.default.parseJSON(node.getAttribute('data-slot-sizes'));
        this.defineSlot(ref, sizes, id, jquery_1.default(node));
        this.display(id);
        this.processed.push(node);
    };
    ResponsiveAdManager.prototype.defineSlot = function (ref, sizes, id, node) {
        var bus = Widget_1.Widget.getBus();
        googletag.cmd.push(function () {
            var slot = googletag.defineSlot(ref, sizes, id);
            slot.addService(googletag.pubads());
            googletag.pubads().addEventListener('slotRenderEnded', function (event) {
                if (slot !== event.slot) {
                    return;
                }
                var iframe = node.find('div > iframe');
                if (event.isEmpty || iframe.height() === 5 && iframe.width() === 5) {
                    node.addClass('no-ad');
                    bus.notify('no-ad');
                }
                else {
                    if (ref.indexOf('Desktop_RectangleHalfpage') > -1 && node.hasClass('no-ad-title-before') === false) {
                        node.addClass('ad-rendered ad-title-before');
                    }
                    else {
                        node.addClass('ad-rendered');
                    }
                    bus.notify('ad-rendered');
                }
            });
        });
    };
    ResponsiveAdManager.prototype.display = function (id) {
        googletag.cmd.push(function () {
            googletag.pubads().collapseEmptyDivs();
            googletag.enableServices();
            googletag.display(id);
            googletag.pubads().refresh(id);
        });
    };
    return ResponsiveAdManager;
}());
exports.ResponsiveAdManager = ResponsiveAdManager;
